module.exports = __webpack_public_path__ + "images/klinkerhof-1fab2b80bb81bc43a05d20b0a010cd20.jpg";